import { atom } from 'recoil';

export const refreshExternalCasesAtom = atom<object>({
    key: 'refreshExternalCases',
    default: {}
});
